module.exports = __webpack_public_path__ + "img/GS_Profile-Maria Sithole.68146022.png";